import useSubscription from '@/hooks/useSubscription'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Topics } from '@/redux/store/common/topic'
import { WalletPlayUser } from '@/redux/store/entities/game.entity'
import { selectIsLogged, selectUser, selectUserId } from '@/redux/store/modules/auth.slice'
import preferenceSlice, { selectActiveCurrency } from '@/redux/store/modules/preference.slice'
import walletSlice, { getListWallets, getWalletByCurrency, selectWallet } from '@/redux/store/modules/wallet.slice'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useCurrencyParams() {
  const [params] = useSearchParams()
  const isLogged = useAppSelector(selectIsLogged)
  const currency = params.get('currency')

  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!isLogged) return
    if (currency) {
      dispatch(getWalletByCurrency(currency))
    }
  }, [currency, isLogged])
}

export default function WalletBalanceSubscription() {
  const dispatch = useAppDispatch()
  const wallet = useAppSelector(selectWallet)
  const user = useAppSelector(selectUser)

  const currency = useAppSelector(selectActiveCurrency)

  useEffect(() => {
    if (!wallet?.id) {
      dispatch(getListWallets())
      if (!currency && user && user.default_wallet) {
        dispatch(preferenceSlice.actions.activeWalletUpdated(user.default_wallet))
      }
    }
  }, [])

  const userId = useAppSelector(selectUserId) || ''

  const _message = useSubscription(Topics.walletBalance(userId))
  const message = _message?.message?.message

  useEffect(() => {
    if (!message) return
    try {
      const data = JSON.parse(message.toString() || '') as WalletPlayUser
      dispatch(walletSlice.actions.walletUpdated(data))
    } catch (error) {
      console.warn('WalletBalanceSubscription error: ', error)
    }
  }, [message])

  return <></>
}
